// Deterministic clinical alerts, IP Case Sheet flavour.
//
// ── What this component must never do ────────────────────────────
//
// These come from backend/utils/ipSafetyRules.js — plain functions over rows.
// They are NOT AI output, they are delivered in their own field, and nothing
// the model says can add, remove or re-rank one. This component renders
// `caseSheet.alerts` and nothing else, which is what makes that guarantee
// visible at the last mile.
//
// The rendering itself moved to components/ui/AlertStrip.tsx (the
// Consultation wireframe's marker 2) so the IP alerts, the OP prescribing
// checks and the Consultation allergy strip are one component rather than
// three copies that drift. This file is now only the mapping from the Case
// Sheet's own `ClinicalAlert` shape onto it — including the two behaviours
// the shared component preserves: red never collapses, and every alert
// carries its published clinical basis behind "Why?".
import { AlertStrip as SharedAlertStrip, type StripAlert } from '@/components/ui/AlertStrip';
import type { ClinicalAlert, SourceRef } from './types';
import { SourceLink } from './ui';

export function AlertStrip({ alerts, onOpen }: { alerts: ClinicalAlert[]; onOpen?: (r: SourceRef) => void }) {
  const mapped: StripAlert[] = alerts.map(a => ({
    key: a.rule_key + a.message,
    label: a.label,
    severity: a.severity,
    message: a.message,
    detail: a.detail,
    basis: a.clinical_basis,
    basisMeta: `rule v${a.rule_version}`,
    action: <SourceLink source={a.source} onOpen={onOpen} label="Open record" />,
  }));
  return <SharedAlertStrip alerts={mapped} />;
}
